const config = {
  getServerTime: {
    code: 10000,
    data: '@1111',
  },
};

export default config;
